/**
 * Códigos de erro do Auth0 (campo `error` do GenericError do auth0-spa-js) que
 * significam "a sessão não vale mais, precisa logar de novo" — não falha de
 * servidor. O mais comum é `invalid_grant`: o `POST /oauth/token` responde 403
 * quando o refresh token em cache (localStorage) foi revogado ou expirou.
 */
const SESSION_ERROR_CODES = new Set([
  'login_required',
  'consent_required',
  'interaction_required',
  'missing_refresh_token',
  'invalid_grant',
  'access_denied',
  'unauthorized',
]);

// Fallback por mensagem para erros que chegam sem o campo `error`.
const SESSION_ERROR_MESSAGES = [
  'Missing Refresh Token',
  'Login required',
  'Consent required',
  'missing_refresh_token',
  'invalid refresh token',
];

export function isAuth0SessionError(err: unknown): boolean {
  const code = (err as { error?: unknown } | null)?.error;
  if (typeof code === 'string' && SESSION_ERROR_CODES.has(code)) {
    return true;
  }
  const msg = err instanceof Error ? err.message.toLowerCase() : '';
  return SESSION_ERROR_MESSAGES.some((m) => msg.includes(m.toLowerCase()));
}
